import { NavLink, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";
import {
  LayoutDashboard,
  FileText,
  Users,
  Car,
  Package,
  ChevronDown,
} from "lucide-react";
import { useNavigate } from "react-router-dom";
import { logout } from "@/auth/logout";
import { toast } from "sonner";

export default function Sidebar() {
  const navigate = useNavigate();
  const location = useLocation();
  const [clientesOpen, setClientesOpen] = useState(false);

  // Abre automaticamente se estiver em /clientes
  useEffect(() => {
    if (location.pathname.startsWith("/clientes")) {
      setClientesOpen(true);
    }
  }, [location.pathname]);


  async function handleLogout() {
    try {
      await logout();
      toast.success("Você saiu do sistema ✅");
      navigate("/login", { replace: true });
    } catch {
      toast.error("Erro ao sair");
    }
  }

  const linkBase =
    "flex items-center gap-3 px-4 py-2 rounded-md text-sm transition";

  const linkActive = "bg-blue-600 text-white";
  const linkInactive = "text-slate-300 hover:bg-slate-700";

  return (
    <aside className="w-64 bg-slate-900 text-white flex flex-col">
      {/* Logo */}
      <div className="h-16 flex items-center justify-center border-b border-slate-800">
        <img src="/em_logo.png" alt="Auto Mecânica" className="h-10" />


      </div>
      <div className="h-6 flex items-center justify-center  ">
        <h1>EM Auto Mecânica</h1>
      </div>

      {/* Menu */}
      <nav className="flex-1 p-3 space-y-1">

        <NavLink
          to="/"
          className={({ isActive }) =>
            `${linkBase} ${isActive ? linkActive : linkInactive}`
          }
        >
          <LayoutDashboard size={18} />
          Dashboard
        </NavLink>

        <NavLink
          to="/os"
          className={({ isActive }) =>
            `${linkBase} ${isActive ? linkActive : linkInactive}`
          }
        >
          <FileText size={18} />
          Ordens de Serviço
        </NavLink>

        {/* CLIENTES */}
        <button
          onClick={() => setClientesOpen(!clientesOpen)}
          className={`${linkBase} w-full justify-between ${clientesOpen ? "bg-slate-800" : linkInactive
            }`}
        >
          <div className="flex items-center gap-3">
            <Users size={18} />
            Clientes
          </div>
          <ChevronDown
            size={16}
            className={`transition-transform ${clientesOpen ? "rotate-180" : ""
              }`}
          />
        </button>

        {clientesOpen && (
          <div className="ml-6 mt-1 space-y-1">
            <NavLink
              to="/clientes"
              end
              className={({ isActive }) =>
                `${linkBase} ${isActive ? linkActive : linkInactive
                }`
              }
            >
              Listar Clientes
            </NavLink>

            <NavLink
              to="/clientes/novo"
              className={({ isActive }) =>
                `${linkBase} ${isActive ? linkActive : linkInactive
                }`
              }
            >
              Cadastrar Cliente
            </NavLink>
          </div>
        )}

        <NavLink
          to="/veiculos"
          className={({ isActive }) =>
            `${linkBase} ${isActive ? linkActive : linkInactive}`
          }
        >
          <Car size={18} />
          Veículos
        </NavLink>

        <NavLink
          to="/pecas"
          className={({ isActive }) =>
            `${linkBase} ${isActive ? linkActive : linkInactive}`
          }
        >
          <Package size={18} />
          Peças / Estoque
        </NavLink>
      </nav>

      {/* Rodapé */}
      <div className="p-3 border-t border-slate-800">
        <button onClick={handleLogout} className="w-full text-left text-sm text-slate-400 hover:text-white">
          Sair
        </button>
      </div>
    </aside>
  );
}
